module.exports = __webpack_public_path__ + "media/images/flags/32/Anguilla-a6306e83c568fe11963769a6a3397a2b.png";